'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var stringify = function stringify(value) {
  return (0, _lodash.isObject)(value) || (0, _lodash.isArray)(value) ? JSON.stringify(value) : value;
};

exports.default = stringify;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/stringify.js